import Modal from './Modal';

interface DiagnosticModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  title: string;
}

export default function DiagnosticModal({ isOpen, onClose, url, title }: DiagnosticModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      maxWidth="max-w-5xl"
      maxHeight="h-[90vh]"
    >
      <iframe
        src={url}
        className="w-full h-full min-h-[70vh]"
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
    </Modal>
  );
}
